module.exports = __webpack_public_path__ + "img/openGroup.60d63937.svg";